import Reveal from "@/components/Reveal";

const milestones = [
  {
    year: "Início",
    title: "Empreendedor e gestor",
    body: "Atuação direta em operações comerciais e gestão financeira aplicada ao comércio.",
  },
  {
    year: "36 meses",
    title: "1 → 17 franquias",
    body: "Liderou a expansão de uma rede de franquias de 1 para 17 unidades em três anos.",
  },
  {
    year: "+18 anos",
    title: "Mentor empresarial",
    body: "Apoio a empresas na recuperação da lucratividade e no restabelecimento do controle financeiro e estratégico.",
  },
  {
    year: "2025",
    title: "Coautor Empretec SEBRAE/ONU",
    body: "Metodologista da versão 2025 — uma das mais relevantes iniciativas de desenvolvimento do comportamento empreendedor no mundo.",
  },
  {
    year: "Hoje",
    title: "Do Custo ao Lucro",
    body: "Programa próprio de precificação para restaurantes — traduz estratégia e comportamento em decisões objetivas.",
  },
  {
    year: "Credenciamento",
    title: "Sebrae · CRA/SC 26456",
    body: "Consultor e instrutor credenciado ao Sebrae, registrado no Conselho Regional de Administração.",
  },
];

const Timeline = () => {
  return (
    <ol className="relative mt-16 space-y-10 md:space-y-12">
      {/* vertical rail */}
      <span
        aria-hidden="true"
        className="absolute left-[7px] top-2 bottom-2 w-px bg-gradient-to-b from-accent/60 via-border to-transparent md:left-[9px]"
      />
      {milestones.map((m, i) => (
        <Reveal as="li" key={m.title} delay={i * 70} className="relative pl-8 md:pl-12">
          {/* dot */}
          <span
            aria-hidden="true"
            className="absolute left-0 top-1.5 flex h-4 w-4 items-center justify-center md:h-5 md:w-5"
          >
            <span className="absolute inline-flex h-full w-full rounded-full bg-accent/20" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent md:h-2.5 md:w-2.5" />
          </span>

          <div className="text-[0.7rem] uppercase tracking-[0.22em] text-accent">
            {m.year}
          </div>
          <h3 className="mt-1 font-serif text-xl font-light leading-tight text-foreground md:text-2xl">
            {m.title}
          </h3>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-muted-foreground md:text-base">
            {m.body}
          </p>
        </Reveal>
      ))}
    </ol>
  );
};

export default Timeline;
